import { createFileRoute } from "@tanstack/react-router";
import { MarginOptimizationPage } from "../../../../pages/margin-optimization-page/margin-optimization-page";

export const Route = createFileRoute("/_auth/_project/margin-optimization/$projectId/$subProjectId/")({
  component: MarginOptimizationPage,
});
